<template>
  <div class="header">
    <div class="menu_box">
        <!-- <img class="logo" alt="" :src="img_url + getClient.channel_logo" > -->
        <a class="link" @click="toHome">91CQ-会员站</a>
        <a href="https://npc.91cq.com"  target="_blank" class="link">游戏攻略</a>
        <router-link to="/member/level" class="link">会员福利</router-link>
        <a v-if="material.shouquan" :href="material.shouquan !=='' ? img_url + material.shouquan :'javascript:0'" target="_blank" class="link">授权查询</a>
        <a class="link" href="https://npc.91cq.com" target="_blank">游戏查询</a>
    </div>
    <div class="menu_box">
        <router-link to="/helps" class="link">服务中心</router-link>
        <!-- <router-link to="/beginnerTutorial" class="link">新手教程</router-link> -->
        <a href="https://docs.qq.com/doc/DYkhTZ3hXRFhobWZp?u=f6cb3fe9d6734bcaaac787d359552e21"  target="_blank" class="link">新手教程</a>
        <router-link to="/member" v-if="isLogin" class="link">用户中心</router-link>
        <a class="link" v-if="unLogin" @click="LoginOne">登录/注册</a>
    </div>
    <Login ref="login" @closeLogin="closeLogin"></Login>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Login from "../components/Login.vue";
export default {
    name:'Header4',
    components:{
            Login
        },
    data(){
        return{

        }
    },
    computed:{
        ...mapState([
            'material',
            'getClient',
            'isLogin',
            'unLogin',
        ])
    },
    methods:{
        toHome(){
            this.$router.push({
                path:'/home'
            })
        },
        closeLogin(){
            $("body").parent().css("overflow-y","auto")
            $("body").parent().css("overflow-x","auto")
        },
        LoginOne(){
            this.$refs.login.open()
            $("body").parent().css("overflow-y","hidden")
            $("body").parent().css("overflow-x","hidden")
        },
    }
}
</script>

<style scoped>
.header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 50px;
    align-items: center;
    background: #fff;
    padding: 0 30px;
}
.logo{
    width: 80px;
}
.menu_box{
    display: flex;
}
.link{
    margin:0 8px;
    cursor: pointer;
    color: inherit;
    font-weight: 400;
    font-size: 14px;
    text-decoration: none;
    display: flex;
    align-items: center;
}
</style>